module.exports = __webpack_public_path__ + "img/buy_big_light.8b393e33.png";